export const BANNER_CATEGORY = "Banner";
export const MANUALS_CATEGORY = "Manual";
export const CATALOGS_CATEGORY = "catalogs";
export const SKITRS_CATEGORY = "Faldon";